import { useEffect, useState } from 'react';

import { Dialog, DialogContent } from '@playbooks/ui/components/dialog';

import { AgentSkillFlowForm } from 'components/agent/agent-skill-flow-form';
import { AgentSkillFlowSelect } from 'components/agent/agent-skill-flow-select';

const AgentSkillFlow = ({
	open,
	setOpen,
	initialView = 'select',
	selected = [],
	onSave,
	libraryOnly = true,
	canManageResources = true,
	onCreate = null,
	onUpdate = null,
	initialModel = null,
	closeAfterSave = false,
	projectLocal = false,
}) => {
	const [view, setView] = useState(initialView);
	const [model, setModel] = useState(null);
	const [values, setValues] = useState(selected);

	useEffect(() => {
		if (!open) return;
		setModel(initialModel);
		setValues(selected);
		setView(initialView);
	}, [initialModel, initialView, open, selected]);

	const onClose = () => setOpen(false);
	const onCreated = skill => {
		if (closeAfterSave) return onClose();
		setValues(current => [skill, ...current.filter(item => item.id !== skill.id)]);
		setModel(null);
		setView('select');
	};

	return (
		<Dialog open={open} onOpenChange={nextOpen => !nextOpen && onClose()}>
			<DialogContent variant='form' className='sm:max-w-2xl'>
				{view === 'select' ? (
					<AgentSkillFlowSelect
						selected={values}
						setSelected={setValues}
						onClose={onClose}
						onAdd={() => setView('form')}
						onEdit={skill => {
							setModel(skill);
							setView('form');
						}}
						onSave={async () => {
							await onSave(values);
							onClose();
						}}
						libraryOnly={libraryOnly}
						canManageResources={canManageResources}
					/>
				) : canManageResources ? (
					<AgentSkillFlowForm
						model={model}
						onPrev={() => setView('select')}
						onNext={onCreated}
						onCreate={onCreate}
						onUpdate={onUpdate}
						projectLocal={projectLocal}
					/>
				) : null}
			</DialogContent>
		</Dialog>
	);
};

export { AgentSkillFlow };
